import { Injectable, OnDestroy } from '@angular/core';
import { Howl } from 'howler';
import { Subscription } from 'rxjs';

import { ConversationClientDisplay } from '../../../common/conversation/conversation-client-display/conversation-client-display';

@Injectable({
  providedIn: 'root',
})
export class IncomingMessageSoundService implements OnDestroy {
  /////////////////////////////////////////////////////////////////////////////////////////////
  // State
  /////////////////////////////////////////////////////////////////////////////////////////////

  private readonly notificationSound = new Howl({
    src: ['assets/sounds/incoming-chat-notification.mp3'],
    volume: 0.7,
  });

  private subscription: Subscription | undefined;

  private client: ConversationClientDisplay | undefined;

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Public Methods
  /////////////////////////////////////////////////////////////////////////////////////////////

  public subscribe(client: ConversationClientDisplay): void {
    this.unsubscribe();
    this.client = client;

    this.subscription = client.messageAdded$.subscribe((message) => {
      if (message.participantSid === this.client?.getSelectedConversationThisParticipantSid()) {
        return;
      }
      this.playNotificationSound();
    });
  }

  public unsubscribe(): void {
    this.subscription?.unsubscribe();
    this.subscription = undefined;
    this.client = undefined;
  }

  public ngOnDestroy(): void {
    this.unsubscribe();
  }

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Private Methods
  /////////////////////////////////////////////////////////////////////////////////////////////

  private playNotificationSound(): void {
    try {
      this.notificationSound.play();
    } catch (error) {
      console.warn('Failed to play incoming message notification sound:', error);
    }
  }
}
